<script setup lang="ts">
import type { ContentProductPackage } from '~/models/Content/ContentProductPackage'
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import { useUrlBuilder } from '~/composables/useUrlBuilder'
import useGradeString from '~/composables/useGradeString'
import { isFlexibleExam, isStaticExam } from '~/composables/useAssignTags'
import Button from '~/components/ui/Button.vue'

const { resource } = defineProps<{
  resource: ContentProductPackage
}>()

const { buildResourceUrl } = useUrlBuilder()
const { createGradeString } = useGradeString()
const { t } = useI18n()

const subtitle = computed(() => {
  const grades = createGradeString(resource.grades)

  return [grades, t('termExam.title')].filter(Boolean).join(' | ')
})

const buttonText = computed(() => {
  if (isFlexibleExam(resource))
    return t('assign.seeAndEdit')
  if (isStaticExam(resource))
    return t('assign.seeExam')
  return t('assign.seeAndCreate')
})
</script>

<template>
  <article class="group border-blue-5 relative size-full rounded-md border-2 bg-white p-3 transition">
    <div class="mb-2 space-y-1">
      <p
        class="text-gray-40 text-xs font-medium tracking-wider uppercase"
        v-text="subtitle"
      />
      <h3
        class="text-lg font-bold text-gray-50"
        v-text="resource.title"
      />
    </div>
    <div class="bg-blue-10 pointer-events-none aspect-[5/2] overflow-hidden rounded">
      <img
        v-if="resource.thumbnail"
        class="size-full rounded-md object-cover"
        :src="resource.thumbnail"
        :alt="resource.thumbnailAlt || ''"
      >
    </div>
    <div class="mt-3 space-y-2">
      <Button
        :to="buildResourceUrl(resource)"
        full-width
        center
        color="blue"
        shade="light"
      >
        {{ buttonText }}
      </Button>
    </div>
  </article>
</template>
